import './index.less'

import { getOldInviteNewTitle, oldInviteNewSubscribe, } from "@utils/api.js"
import { isiOS, copyString, } from "@utils/index.js"

export default class OldInviteNewReferral {
  constructor() {
    this.skeletonWrap = document.querySelector('.old-invite-new-skeleton-wrap')
    this.contentWrap = document.querySelector('.old-invite-new-content-wrap')

    if (this.skeletonWrap && this.contentWrap) {
      this.titleDOM = document.querySelector('[data-old-invite-new-invite-title]')
      this.descriptionDOM = document.querySelector('[data-old-invite-new-invite-description]')
      this.formDOM = document.querySelector('#old-invite-new-invite-form')
      this.couponDOM = document.querySelector('[data-old-invite-new-coupon]')

      this.init()
    }
  }
  async init() {
    try {
      const { data } = await getOldInviteNewTitle()

      let titleHTML = this.titleDOM.innerHTML
      titleHTML = titleHTML.replace('{coupon}', data)
      this.titleDOM.innerHTML = titleHTML
    } catch(err) {
      this.titleDOM.innerHTML = ''
    } finally {
      this.renderPolicy()
      this.registerFormButton()

      // 隐藏 骨架屏
      this.skeletonWrap?.parentElement?.removeChild(this.skeletonWrap)

      // 显示内容区域
      this.contentWrap.classList.remove('!hidden')
    }
  }
  renderPolicy() {
    const labelDOM = this.formDOM.querySelector('label')
    const spanDOM = labelDOM.querySelector('span')
    const { terms_service, terms_service_url, privacy_policy, privacy_policy_url, } = spanDOM.dataset
    let spanHTML = spanDOM.innerHTML

    const termsServiceHtml = `<a href="${terms_service_url}" target="_blank" class="text-#666 hover:text-primary underline underline-offset-4">${terms_service}</a>`
    const privacyPolicyHtml = `<a href="${privacy_policy_url}" target="_blank" class="text-#666 hover:text-primary underline underline-offset-4">${privacy_policy}</a>`

    spanHTML = spanHTML.replace('{termsService}', termsServiceHtml)
    spanHTML = spanHTML.replace('{PrivacyPolicy}', privacyPolicyHtml)
    spanDOM.innerHTML = spanHTML
  }
  // 注册 表单按钮
  registerFormButton() {
    const inputDOM = this.formDOM.querySelector('[data-old-invite-new-form-input]')
    const buttonDOM = this.formDOM.querySelector('[data-old-invite-new-form-button]')
    const labelDOM = this.formDOM.querySelector('label')
    const emailErrorTip = this.formDOM.querySelector('[data-email-error-tip]')
    const policyErrorTip = this.formDOM.querySelector('[data-policy-error-tip]')

    const { emailEmptyErrorText, emailFormatErrorText, } = inputDOM.dataset

    // input change
    inputDOM.addEventListener('input', (e) => emailErrorTip.classList.add('hidden'))
    labelDOM.querySelector('input[type="checkbox"]').addEventListener('change', (e) => policyErrorTip.classList.add('hidden'))

    this.formDOM.addEventListener('submit', async (e) => {
      e.preventDefault()
      
      buttonDOM.classList.add('btn--loading')
      const email = inputDOM.value
      if (!email.trim()) {
        emailErrorTip.innerText = emailEmptyErrorText
        emailErrorTip.classList.remove('hidden')

        buttonDOM.classList.remove('btn--loading')
        return false
      }
      if (!/^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/.test(email)) {
        emailErrorTip.innerText = emailFormatErrorText
        emailErrorTip.classList.remove('hidden')
        
        buttonDOM.classList.remove('btn--loading')
        return false
      }

      const isChecked = labelDOM.querySelector('#old-invite-new-agree-checkbox').checked
      if (!isChecked) {
        policyErrorTip.innerText = labelDOM.dataset.policyErrorText
        policyErrorTip.classList.remove('hidden')

        buttonDOM.classList.remove('btn--loading')
        return false
      }

      try {
        // 订阅
        const pageSource =  getUrlQueryParams('pageSource')
        let  tags = "ReferNew-Subscribe"
        if(pageSource == 'rank'){
          tags = "ReferNew-PHB-Subscribe"
        }else if(pageSource == 'activity'){
          tags = "ReferNew-Subscribe"
        }else if(pageSource == 'life'){
          tags = "ReferNew-JL-Subscribe"
        }

        const { data, message, } = await oldInviteNewSubscribe({ email, inviteCode: getUrlQueryParams('referralCode') || '', tags })

        buttonDOM.classList.remove('btn--loading')

        if (data) {
          this.formDOM.classList.add('!hidden')
          this.couponDOM.classList.remove('!hidden')

          this.descriptionDOM.innerHTML = this.descriptionDOM.dataset.purchaseGuidance
          this.couponDOM.querySelector('img').src = data.imageUrl

          const { codeText, copyAndUseSuccessfully, } = this.couponDOM.dataset

          // Code
          this.renderCode(codeText, data.discountCode, copyAndUseSuccessfully)

          // Rules
          this.couponDOM.querySelector('[data-old-invite-new-rule]').onclick = (e) => this.handleRuleClick(e, data)
          
          // Copy and Use
          this.registerCopyAndUse(data.discountCode, copyAndUseSuccessfully)

          // 数据埋码
          this.GAEvent({
            module: this.titleDOM.innerText || 'New customer Subscribe',
            button_name: buttonDOM.querySelector('span').innerText,
            status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
          })
        } else {
          pushErrorMessage(message);
        }
      } catch(err) {
        buttonDOM.classList.remove('btn--loading')
      }
    })
  }
  // Code
  renderCode(codeText, discountCode, copyAndUseSuccessfully) {
   
    const codeDOM = this.couponDOM.querySelector('[data-old-invite-new-code]')
    codeDOM.innerText = `${codeText}:${discountCode}`

    codeDOM.onclick = () => {
      copyString(discountCode, () => {
        // 提示 copy 成功
        pushSuccessMessage(copyAndUseSuccessfully)

        // 数据埋码
        this.GAEvent({
          module: this.titleDOM.innerText || 'New customer Coupon',
          title: discountCode,
          button_name: 'coupon_code',
          status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
        })
      })
    }
  }
  // Copy and Use
  registerCopyAndUse(discountCode, copyAndUseSuccessfully) {
    const copyUseBtn = this.couponDOM.querySelector('[data-old-invite-new-copy-use-button]')
    copyUseBtn.onclick = (e) => {
      const target = e.target.tagName === 'SPAN' ? e.target.parentElement : e.target
      target.setAttribute('disabled', 'disabled')

      copyString(discountCode, () => {
        const { copyAndUseLink, } = target.dataset

        // 提示 copy 成功
        pushSuccessMessage(copyAndUseSuccessfully)

        // 数据埋码
        this.GAEvent({
          module: this.titleDOM.innerText || 'New customer Coupon',
          title: discountCode,
          button_name: target.querySelector('span').innerText,
          status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
        })

        setTimeout(() => {
          target.removeAttribute('disabled')
          
          if (copyAndUseLink) {
            // 因为苹果的安全机制拦截了，所以不能打开新的标签页
            isiOS() ? (window.location.href = copyAndUseLink) : window.open(copyAndUseLink, '_blank')
          }
        }, 3000)
      })
    }
  }
  // 邮箱弹窗内容
  renderRulePopup(imageUrl, ruleInfo) {
    const { ruleText, } = this.couponDOM.dataset
    return `
      <div class="old-invite-new-rule-popup-wrap">
        <div class="w-462 h-180 lg:j-w-287 lg:j-h-106 xl:a-w-287 xl:a-h-106">
          <img class="w-auto h-full object-contain scale-145 origin-left" src="${imageUrl}" alt="">
        </div>
        
        <h3 class="font-medium text-#1A1A1A leading-none text-36 mt-16 lg:j-text-18 lg:j-mt-30 xl:a-text-18 xl:a-mt-30">${ruleText}</h3>

        <div class="w-full text-#666 mt-16 text-28 leading-40 lg:j-mt-10 lg:j-text-16 lg:j-leading-24 xl:a-mt-10 xl:a-text-16 xl:a-leading-24">${ruleInfo}</div>
      </div>
    `
  }
  handleRuleClick(e, { imageUrl, ruleInfo, discountCode, }) {
    const popupHtml = this.renderRulePopup(imageUrl, ruleInfo)
    window.ZModle.getInstance(popupHtml, {
      id: `old-invite-new-rule-popup`,
      class: "old-invite-new-rule-popup-wrap",
      cb: () => {
        // 数据埋码
        this.GAEvent({
          module: this.titleDOM.innerText || 'New customer Coupon',
          title: discountCode,
          button_name: e.target.innerText,
          status: window?.pageInfo?.customerInfo?.id ? 'logged_in' : 'tourist',
        })
      }
    })
  }

  // 数据埋码
  GAEvent(params) {
    window.dataLayer.push({ "event_parameters": null });
    window.dataLayer.push({
      "event":"ga4Event",
      "event_name":"refer_new_user_clicks",
      "event_parameters":{
        "current_page": window.location.href, // current page url
        ...params
      }
    });
  }
}